import { flexRender, Table } from "@tanstack/react-table";
import React, { useMemo } from "react";
import { TableData } from "shared/ui";
import { TableRows } from "../rows";
import { ITableColumns } from "../table";

interface ITableBody {
  table: Table<TableData>;
  expandableColumn?: string;
  defaultRows?: number;
  placeholder?: boolean;
  empty?: React.ReactNode;
  header: ITableColumns[];
}

export const TableBody = (props: ITableBody) => {
  const defaultArray = useMemo(() => {
    return Array(props.defaultRows)
      .fill(1)
      .map((_, index) => index);
  }, [props.defaultRows]);

  return (
    <tbody>
      {props.table.getRowModel().rows.length === 0 && props.placeholder
        ? defaultArray.map((elem, index) => (
            <tr key={index}>
              {props.table.getAllColumns().map((elem, index) => (
                <td key={index}> </td>
              ))}
            </tr>
          ))
        : ""}
      {props.table.getRowModel().rows.map((row) => (
        <TableRows row={row} key={row.id} header={props.header} expandableColumn={props.expandableColumn} />
      ))}
    </tbody>
  );
};

TableBody.defaultProps = {};
